import React, { useCallback, useEffect, useState } from "react";
import Header from "../../Components/Header";
import DashboardLogo from "../../assets/Svg/dashboard-logo.svg";
import { Row, Col, Flex } from "antd";
import {
  Image,
  Spacer,
  Button,
  Card,
  CardBody,
  Badge,
} from "@nextui-org/react";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "../../assets/images/Search.png";
import ButtonSlider from "../../Components/ButtonSlider";
import { useNavigate } from "react-router-dom";
import CartMenuIcon from "../../assets/images/cart_menu.svg";
import { Paths } from "../../Services/EndPoints";
import { post, unAuthGet } from "../../Services/api.service";
import { isEmpty, size } from "lodash";
import { setStoreFilter } from "../../Redux/Actions";
import { categoryList, EmptyData } from "../../Utils/Strings";
import { useAuth } from "../../Hooks/AuthContext";
import HorizontalSlider from "../../Components/CustomSlider";
import { useNotification } from "../../Components/CustomStatus/UseNotification";
import { ButtonSliderShimmer, StoreSkelton } from "../../Utils/Mock";
import Spinner from "../../Components/Spinner";
import { formatAmount } from "../../Utils/HelperFunctions";
import { useHistoryContext } from "../../Routes/HistoryContext";
import defaultProductImage from "../../assets/images/default-product.png";
import gradient from "../../assets/images/gradient.png";
import hempty from "../../assets/Svg/hempty.svg";
import hFill from "../../assets/Svg/hfill.svg";
import CardSlider from "../../Components/SliderCards/CardSlider";
import smallexc from "../../assets/Svg/small-exc.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import spinnersvg from "../../assets/Svg/spinnersvg.svg";

export const CartQuantity = ({ isInvisible }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const cartQuantity = useSelector((state) => state.cartQuantity);
  const [value, setValue] = useState(0);

  const fetchCartQuantity = () => {
    unAuthGet(Paths?.get_cart_count)
      .then((res) => {
        setValue(res?.data);
      })
      .catch((err) => console.log(err));
    // .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchCartQuantity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartQuantity]);

  useEffect(() => {
    if (!user) {
      setValue(0);
    }
  }, [user]);
  return (
    <Button
      isIconOnly
      variant="light"
      color="#000"
      onClick={() => navigate("/cart-products")}
      className="bg-[#d5dde2]"
    >
      <Badge
        size="sm"
        content={value || 0}
        color="primary"
        isInvisible={value === 0}
      >
        <Image width={20} src={CartMenuIcon} alt="" />
      </Badge>
    </Button>
  );
};

export default function MyStore() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const history = useHistoryContext();
  const { openToast } = useNotification();
  const previousPath = history[history?.length - 2];
  const storeDetails = useSelector((state) => state.storeDetails);
  const storeFilter = useSelector((state) => state.storeFilter);
  const [storeData, setStoreData] = useState([]);
  const [selectedButton, setSelectedButton] = React.useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [isFilterChecked, setIsFilterChecked] = React.useState(false);
  const [likedStatus, setLikedStatus] = useState([]);
  const [spin, setSpin] = useState(false);
  const selectedFilters = JSON.parse(sessionStorage.getItem("filters"));
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [isDataReady, setIsDataReady] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const addToWishlist = (productId, skuId, qty) => {
    setSpin(true);
    post(Paths?.add_to_wishlist, {
      productId: productId,
      skuId: skuId,
      qty: qty,
    })
      .then((res) => {
        setLikedStatus((prev) => [...prev, skuId]);
        openToast({
          content: "Product added to wishlist.",
          type: "success",
        });
      })
      .catch((err) => console.log(err))
      .finally(() => setSpin(false));
  };
  const deleteItem = (skuId) => {
    setSpin(true);
    post(Paths?.delete_wishlist_item, {
      skuId: skuId,
    })
      .then((res) => {
        if (res?.status === "SUCCESS") {
          setLikedStatus((prev) => prev.filter((id) => id !== skuId));
          openToast({
            content: "Product removed from wishlist.",
            type: "success",
          });
        } else {
          openToast({
            content: "Failed to remove product from wishlist",
            type: "error",
          });
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setSpin(false));
  };

  const fetchStoreFilter = useCallback(() => {
    setIsFilter(true);
    unAuthGet(Paths.store_filter)
      .then((res) => {
        if (!isEmpty(res?.data)) {
          dispatch(setStoreFilter(res?.data));
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setIsFilter(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const fetchStoreData = (selectedButton, page = 1) => {
    if (page === 1) {
      setIsLoading(true);
      setIsDataReady(false);
      setStoreData([]);
    }

    unAuthGet(
      Paths.store_data +
        `?categoryIds=${
          isEmpty(selectedButton) ? "" : selectedButton
        }&pageNo=${page}&pageSize=${10}`
    )
      .then((res) => {
        if (!isEmpty(res?.data)) {
          const newCategories = res?.data?.healthConcernProducts;
          if (page === 1) {
            setStoreData(newCategories);
          } else {
            setStoreData((prevData) => {
              const updatedData = [...prevData];

              newCategories.forEach((newCategory) => {
                const existingIndex = updatedData.findIndex(
                  (item) => item.id === newCategory.id
                );

                if (existingIndex >= 0) {
                  updatedData[existingIndex] = {
                    ...updatedData[existingIndex],
                    products: [
                      ...updatedData[existingIndex].products,
                      ...newCategory.products,
                    ],
                  };
                } else {
                  updatedData.push(newCategory);
                }
              });

              return updatedData;
            });
          }

          const currentPage = res?.data?.pageNo;
          const totalPages = res?.data?.totalPages;
          setHasMore(currentPage < totalPages);
          const wishListedProducts = res?.data?.healthConcernProducts.flatMap(
            (category) =>
              category?.products
                .filter((product) => product.wishlisted)
                .map((data) => data.skuId)
          );
          setLikedStatus((prev) => [...prev, ...wishListedProducts]);
        } else {
          if (page === 1) {
            setStoreData([]);
          }
          setHasMore(false);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        if (page === 1) {
          setIsLoading(false);
        }
        setIsDataReady(true);
      });
  };

  useEffect(() => {
    if (isEmpty(storeFilter)) {
      fetchStoreFilter();
    } else {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
    sessionStorage.removeItem("healthCatData");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeFilter]);

  useEffect(() => {
    setIsLoading(true);
    if (
      (previousPath?.startsWith("/product-details") ||
        previousPath === "/view-by-category") &&
      selectedFilters?.page === "myStore"
    ) {
      setSelectedButton(selectedFilters?.selectButton);
      setIsApplyFilter(true);
    }
    setTimeout(() => {
      setIsFilterChecked(true);
      setIsApplyFilter(true);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previousPath]);

  useEffect(() => {
    const handleSelectedButton = () => {
      if (isFilterChecked) {
        sessionStorage.setItem(
          "filters",
          JSON.stringify({
            page: "myStore",
            selectButton: selectedButton,
          })
        );
      }
    };
    handleSelectedButton();
    if (isApplyFilter) {
      scrollToTop();
      setPage(1);
      const timeoutId = setTimeout(() => {
        fetchStoreData(selectedButton, 1);
      }, 100);

      return () => clearTimeout(timeoutId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedButton, isApplyFilter]);

  const loadMoreData = () => {
    if (!isLoading && hasMore) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchStoreData(selectedButton, nextPage);
    }
  };

  return (
    <React.Fragment>
      <div className="min-h-screen">
        <div className="sticky top-0 bg-bgColor px-2 z-20">
          <Header
            image={storeDetails?.storeUrl || DashboardLogo}
            name={storeDetails?.storeName || ""}
            userName={storeDetails?.userName || ""}
            showMenu={true}
            onBellClick={() => navigate("/notifications")}
            onShareClick={() => navigate("/partner/share-store")}
            endContent={<CartQuantity isInvisible={false} />}
            isAffiliate={storeDetails?.affiliated}
          />
        </div>

        {/* {freeDeliveryCard()} */}
        <div className="mb-4 px-2">
          <CardSlider
            fivePercentDiscount={storeDetails?.fivePercentDiscount}
            tenPercentDiscount={storeDetails?.tenPercentDiscount}
            pwa={
              // <div className="my-2">
              //   <InstallPWAButton
              //     storeImage={storeDetails?.storeUrl || DashboardLogo}
              //     name={storeDetails?.storeName || ""}
              //     setShowPwa={setShowPwa}
              //   />
              // </div>
              true
            }
            storeImage={storeDetails?.storeUrl || DashboardLogo}
            name={storeDetails?.storeName || ""}
          />
        </div>
        <div className="bg-bgColor px-2 sticky top-[74px] z-50">
          <Col span={24}>
            <div
              className="flex bg-white rounded-lg px-2 py-4 cursor-pointer"
              onClick={() => navigate("/search")}
            >
              <Image width={"100%"} src={SearchIcon} alt="NextUI Album Cover" />
              <p className="ml-3 text-base font-light text-[#668091]">
                Search by product or brand
              </p>
            </div>

            <Spacer y={4} />
            <div className="mb-2">
              <h3 className="mb-2 font-normal text-md text-secondary">
                Explore our product variety!
              </h3>
              {isFilter ? (
                <ButtonSliderShimmer />
              ) : (
                <ButtonSlider
                  selectedButton={selectedButton}
                  setSelectedButton={setSelectedButton}
                  multiItems={
                    storeFilter ? storeFilter?.allCategories : categoryList
                  }
                  selectionType="multiple"
                  // loading={isLoading}
                />
              )}
            </div>
            <Spacer y={4} />
          </Col>
        </div>
        <Spinner isLoading={spin}>
          <InfiniteScroll
            dataLength={
              storeData.flatMap((category) => category.products).length
            }
            next={loadMoreData}
            hasMore={hasMore}
            scrollThreshold="0.7"
            loader={
              <div className="flex justify-center items-center">
                {/* <p className="text-md text-secondary">Loading...</p> */}
                <img src={spinnersvg} className="w-10 h-10" alt="spinner" />
              </div>
            }
          >
            <Row className="px-3">
              {isLoading || isLoading === null || !isDataReady ? (
                <StoreSkelton />
              ) : (
                <Col span={24}>
                  {isEmpty(storeData) && isDataReady ? (
                    <EmptyData />
                  ) : (
                    storeData?.map((item, index) => {
                      return (
                        <div className="mt-2" key={index}>
                          <Flex justify="space-between" align="middle">
                            <h5 className="font-normal text-md text-secondary my-auto py-2.5">
                              {item.title}
                            </h5>
                            {size(item?.products) > 2 && (
                              <Button
                                variant="light"
                                color="primary"
                                className="text-normal text-primary"
                                onClick={() =>
                                  navigate("/health-concern-list", {
                                    state: {
                                      h_c_id: {
                                        id: item?.id,
                                        name: item?.title,
                                      },
                                    },
                                  })
                                }
                              >
                                View All
                              </Button>
                            )}
                          </Flex>

                          <HorizontalSlider>
                            {item?.products
                              ?.slice(0, 5)
                              ?.map((sub_item, sub_index) => (
                                <Card
                                  shadow="sm"
                                  key={sub_index}
                                  className="mb-2 w-[180px] h-[265px] flex-none "
                                  width={200}
                                >
                                  <CardBody
                                    className="overflow-visible p-0 cursor-pointer"
                                    onClick={() =>
                                      navigate(
                                        `/product-details/${sub_item?.productId}?skuId=${sub_item?.skuId}`
                                      )
                                    }
                                  >
                                    <div className="relative inline-block">
                                      <Image
                                        className="object-fill"
                                        shadow="sm"
                                        radius="md"
                                        width={200}
                                        height={150}
                                        loading="lazy"
                                        alt={item.title}
                                        src={
                                          sub_item.productUrl ||
                                          defaultProductImage
                                        }
                                      />
                                      <img
                                        alt="gradient"
                                        src={gradient}
                                        className="absolute z-10 top-0 right-0 opacity-100 w-40 h-36"
                                      ></img>

                                      {sub_item?.stock === 0 && (
                                        <div className="absolute top-2 left-2 z-10">
                                          <p className="bg-warning font-normal text-sm rounded-lg px-2 py-1 text-white">
                                            Out of Stock
                                          </p>
                                        </div>
                                      )}
                                      {user && (
                                        <Button
                                          isIconOnly
                                          className="absolute top-1 right-1 z-10 bg-white-50"
                                        >
                                          {!likedStatus.includes(
                                            sub_item?.skuId
                                          ) ? (
                                            <Image
                                              src={hempty}
                                              onClick={() =>
                                                addToWishlist(
                                                  sub_item?.productId,
                                                  sub_item?.skuId,
                                                  1,
                                                  sub_index
                                                )
                                              }
                                              width={50}
                                              className="h-8 w-8"
                                            />
                                          ) : (
                                            // <IoIosHeartEmpty
                                            //   onClick={() =>
                                            //     addToWishlist(
                                            //       sub_item?.productId,
                                            //       sub_item?.skuId,
                                            //       1,
                                            //       sub_index
                                            //     )
                                            //   }
                                            //   width={50}
                                            //   color="#fff"
                                            //   className="h-8 w-8"
                                            // />
                                            // <IoIosHeart
                                            //   onClick={() =>
                                            //     deleteItem(sub_item?.skuId)
                                            //   }
                                            //   width={50}
                                            //   color="#f31260"
                                            //   className="h-8 w-8"
                                            // />
                                            <Image
                                              src={hFill}
                                              onClick={() =>
                                                deleteItem(sub_item?.skuId)
                                              }
                                              width={50}
                                              className="h-11 w-11"
                                            />
                                          )}
                                        </Button>
                                      )}
                                    </div>
                                    <div className="px-2 py-2 text-start">
                                      <div className="text-md font-normal text-secondary show_two_lines_text leading-tight tracking-tight">
                                        {sub_item.productName}
                                      </div>
                                      <div className="text-[#516778] text-xs font-normal pt-1 pb-0.5 leading-tight tracking-tight w-full truncate">
                                        By {sub_item?.brandName}
                                      </div>
                                      {sub_item?.variantName && (
                                        <div className="text-[#516778] text-xs font-normal pt-0.5 pb-0.5 leading-tight tracking-tight w-full truncate">
                                          {sub_item?.variantName}
                                        </div>
                                      )}
                                      <div className="flex justify-between items-center">
                                        <Flex>
                                          <p
                                            className={`text-default-500 ${
                                              sub_item?.priceDetails
                                                ?.sellingPrice !==
                                              sub_item?.priceDetails
                                                ?.finalAmount
                                                ? "mr-1"
                                                : ""
                                            } `}
                                          >
                                            <del>
                                              {sub_item?.priceDetails
                                                ?.sellingPrice ===
                                              sub_item?.priceDetails
                                                ?.finalAmount
                                                ? ""
                                                : `${formatAmount(
                                                    sub_item?.priceDetails
                                                      ?.sellingPrice
                                                  )}`}
                                            </del>
                                          </p>
                                          <p className="font-medium text-secondary">
                                            {formatAmount(
                                              sub_item?.priceDetails
                                                ?.finalAmount
                                            )}
                                          </p>
                                        </Flex>
                                        {sub_item?.exclusive && (
                                          <img src={smallexc} alt="tag" />
                                        )}
                                      </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              ))}
                          </HorizontalSlider>
                        </div>
                      );
                    })
                  )}
                </Col>
              )}
            </Row>
          </InfiniteScroll>
        </Spinner>
      </div>
    </React.Fragment>
  );
}
